import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import mixpanel from 'mixpanel-browser';
import { VendorDetailsRequestForm } from './steps/Form/VendorDetailsRequestForm';
import { VendorDetailsRequestIntro } from './steps/Intro/VendorDetailsRequestIntro';
import { useGetVendorDetailsRequest } from './hooks/useGetVendorDetailsRequest';

export const VendorDetailsRequestFlow = () => {
  enum FlowStep {
    INTRO,
    FORM,
  }

  const { t } = useTranslation();

  const [flowState, setFormState] = useState<FlowStep>(FlowStep.INTRO);
  const [searchParams] = useSearchParams();
  const [businessName, setBusinessName] = useState<string | null>(null);
  const [billNumber, setBillNumber] = useState<string | null>(null);
  const [expiredErrorMessage, setExpiredErrorMessage] = useState<string>();
  const { isLoading } = useGetVendorDetailsRequest({
    token: searchParams.get('token') || '',
    onError: (error) => {
      switch (error.code) {
        case 6068: {
          setExpiredErrorMessage(error.message);
          break;
        }
        default: {
          setExpiredErrorMessage(t('ASK_VENDOR.INTRO.EXPIRED_TITLE'));

          break;
        }
      }
      mixpanel.track('View Ask Vendor - Vendor view Intro Screen', {
        'Intro screen status': 'Expired',
      });
    },
    onSuccess: (response) => {
      setBusinessName(response.businessName);
      setBillNumber(response.billNumber);
      mixpanel.track('View Ask Vendor - Vendor view Intro Screen', {
        'Intro screen status': 'Available',
      });
    },
  });
  const onReceivePaymentClick = () => {
    setFormState(FlowStep.FORM);
    mixpanel.track('View Ask Vendor - Vendor view Intro Screen', {
      Action: 'Receive Payment',
    });
  };

  return (
    <div className='w-full  h-full fixed bg-bw01 '>
      <div className='absolute z-[99999] flex items-center justify-center w-full h-full overflow-y-scroll'>
        {flowState === FlowStep.INTRO && (
          <VendorDetailsRequestIntro
            billNumber={billNumber}
            businessName={businessName}
            errorMessage={expiredErrorMessage}
            isLoading={isLoading}
            onReceivePaymentClick={onReceivePaymentClick}
          />
        )}
        {flowState === FlowStep.FORM && businessName && (
          <VendorDetailsRequestForm businessName={businessName} />
        )}
      </div>
    </div>
  );
};
